<template>
  <Reference
    :id="value && value.id"
    :value="value"
    :label="label || 'Проект'"
    placeholder="Введіть назву проекту"
    :items.sync="items"
    :total-items="totalItems"
    component-name="Project"
    :disabled="disabled"
    @input="$emit('input', $event)"
    @getItems="getItems"
  />
</template>

<script>
import * as projectsApi from "@/backend/projectsApi.js";
import Reference from "@/components/Reference";

export default {
  components: {
    Reference,
  },
  props: {
    label: {
      type: String,
      default: "Проект",
    },
    value: {
      type: Object,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    clientId: {
      type: Number,
    },
  },
  data: () => ({
    items: [],
    totalItems: 0,
  }),
  methods: {
    async getItems({ currentPage, perPage, search }) {
      const clientId = this.clientId;
      const { result, totalItems } = await projectsApi.selectProject(
        currentPage,
        perPage,
        search,
        clientId
      );
      this.items = [...result];
      this.totalItems = totalItems;
    },
  },
};
</script>
